module.exports = __webpack_public_path__ + "img/bg-us-1.4514bec6.png";